<template>
    <Dialog v-model:open="opened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <DialogHeader class="items-center">
                <template #icon> <FreeloLogo /> </template>
                <DialogTitle>
                    {{
                        integration
                            ? $t("integrations.freelo.modal.title_edit")
                            : $t("integrations.freelo.modal.title_add")
                    }}</DialogTitle
                >
            </DialogHeader>

            <div class="mt-4 px-6">
                <a
                    href="https://zaptime.cz/blog/propojeni-rezervacniho-kalendare-s-freelo"
                    target="_blank"
                >
                    <div class="gap-1 flex">
                        <HelpCircle
                            class="text-iron-500"
                            :size="20"
                        ></HelpCircle>
                        <p class="text-sm text-iron-700">Pomoc s integrací</p>
                    </div>
                </a>

                <div class="mt-4 gap-1.5 grid w-full items-center">
                    <Label for="ecomail-apikey">{{
                        $t("integrations.freelo.modal.email_label")
                    }}</Label>
                    <Input
                        v-model="email"
                        id="ecomail-apikey"
                        :placeholder="
                            $t('integrations.freelo.modal.email_placeholder')
                        "
                    />
                </div>

                <div class="mt-4 gap-1.5 grid w-full items-center">
                    <Label for="ecomail-apikey">{{
                        $t("integrations.freelo.modal.api_key_label")
                    }}</Label>
                    <Input
                        v-model="apiKey"
                        id="ecomail-apikey"
                        :placeholder="
                            $t('integrations.freelo.modal.api_key_placeholder')
                        "
                    />
                </div>
            </div>
            <DialogFooter
                class="w-full"
                :class="cn(removable ? '!justify-between' : 'justify-end')"
            >
                <Button
                    v-if="removable"
                    @click="$emit('remove-integration')"
                    variant="destructive-ghost"
                    class="gap-1 flex"
                    size="xs"
                >
                    <Trash :size="16" />
                    {{ $t("integrations.remove_integration") }}
                </Button>

                <div class="flex-end flex">
                    <DialogClose>
                        <Button class="ml-4" variant="outline" type="button">{{
                            $t("cancel")
                        }}</Button>
                    </DialogClose>

                    <Button
                        class="ml-4"
                        type="button"
                        @click="createOrUpdateFreeloIntegration"
                        >{{
                            integration ? $t("save_changes") : $t("add")
                        }}</Button
                    >
                </div>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { cn } from "@/lib/utils";
import { ref } from "vue";
import { router } from "@inertiajs/vue3";
import FreeloLogo from "../logos/simple/Freelo.svg";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogClose,
} from "@/components/ui/dialog-v2";
import route from "ziggy-js";
import { Button } from "@/components/ui/button";
import { Trash, HelpCircle } from "lucide-vue-next";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const props = defineProps<{
    integration?: any;
    removable?: boolean;
}>();

console.log(props.integration);

const email = ref(props.integration ? props.integration.data.email : "");
const apiKey = ref(props.integration ? props.integration.data.apiKey : "");

const opened = ref(false);

function create() {
    router.post(
        route("app.freelo-integrations.store"),
        {
            email: email.value,
            apiKey: apiKey.value,
        },
        {
            onFinish: () => {
                closeModal();
            },
        },
    );
}

function update() {
    router.put(
        route("app.freelo-integrations.update", {
            integration: props.integration?.id,
        }),
        {
            email: email.value,
            apiKey: apiKey.value,
        },
        {
            onFinish: () => {
                closeModal();
            },
        },
    );
}

function createOrUpdateFreeloIntegration() {
    if (props.integration) {
        update();
        return;
    }

    create();
}

const closeModal = () => {
    opened.value = false;
};
</script>

<style></style>
